import { NumberIndicator, NumbersContainer } from './style'
import {
  SmartProductItem,
  SmartProductsList,
  SmartSecureProductsTitle,
} from '../smart-products/style'

import { ProductDescription } from '../exposure/style'

export const InTheNumbers: React.FC = () => {
  const contentItems = [
    {
      number: '$50M+',
      description: 'Total volume traded',
    },
    {
      number: '6.5K+',
      description: 'Total investors',
    },
    {
      number: '50K+',
      description: 'Total transactions',
    },
  ]

  return (
    <NumbersContainer>
      <SmartSecureProductsTitle>It&apos;s all in the numbers</SmartSecureProductsTitle>
      <SmartProductsList>
        {contentItems.map((item, index) => (
          <SmartProductItem key={index}>
            <NumberIndicator>{item.number}</NumberIndicator>
            <ProductDescription>{item.description}</ProductDescription>
          </SmartProductItem>
        ))}
      </SmartProductsList>
    </NumbersContainer>
  )
}

export default InTheNumbers
